<template>
    <div>
        <div class="flow-test-viewer" :style="this.style">
            <div class="">
                <div class="language-bubble-wrapper">
                    <LanguageBubble
                        :technologyList="[campaign.challenge_data.technology]"
                        :hasAction="false"
                        style="height:28px"
                    ></LanguageBubble>
                </div>
                <div class="panel-heading panel-heading-editor"><h1>{{ campaign.challenge_data.title }}
                    <span class="current-stage">{{ getCurrentStage() }}</span>
                </h1></div>
                <div class="panel-body">
                    <p v-html="task.description"></p>
                    <div style="margin: 3rem 0 0 0;">
                        <button @click="runTests()"
                                class="btn btn-secondary action-button"
                                style="min-width: 17rem;"
                                :class="{'stop': runTestsRequest.loaded === false}">
                            <i :class="{'dev-play': runTestsRequest.loaded === true, 'loading-spinner': runTestsRequest.loaded === false}">
                            </i>
                            <span v-if="!runTestsRequest.loaded">&nbsp;Stop tests</span>
                            <span v-if="runTestsRequest.loaded">&nbsp;Run tests</span>
                            <span class="hotkey">({{ this.testRunHotKey }})</span>
                        </button>
                        <button v-if="task.hasLiveServer" @click="openLiveServerLink()"
                                class="btn btn-secondary open-server-button action-button"><i
                            class="fa fa-eye"
                            aria-hidden="true"></i>
                            Show Frontend
                        </button>
                        <button v-if="campaign.challenge_data.groupId === '7e912c56-3343-48dd-a256-8c2642c69e19' || campaign.challenge_data.groupId === 'b9698f39-0df3-47e7-ab41-a51c1e785897'"
                                style="min-width: 17rem; display: inline-flex; align-items: center; justify-content: center;"
                                @click="openCompanyCTA('')" data-backdrop="static" data-toggle="modal"
                                class="btn btn-primary action-button"><img width="18"
                                                                           src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1686052229/eh-platform/challenges/reverse-sms/twilio-icon-svgrepo-com.svg"/>&nbsp;Explore
                            Twilio
                        </button>
                        <button @click="submitTask()" data-backdrop="static" data-toggle="modal"
                                href="#submit-task-modal"
                                :disabled="!(taskSolved)"
                                class="btn btn-primary action-button"><i class="dev-check"></i>&nbsp;<template v-if="!isLastStage()">Stage
                            abgeben</template><template v-if="isLastStage()">Challenge abgeben</template>
                        </button>
                        <br><br>
                        <button v-if="this.$features.LIVE_STREAM_CODE" class="btn share-code" title="Code live teilen"
                                @click="shareCode()" ref="theme"><i
                            class="dev-share-screen"></i>
                        </button>
                        <button v-if="isNewEditor" class="btn reload-editor" title="Editor neu laden"
                                @click="reloadPage()" ref="theme"><i
                            class="dev-restart"></i>
                        </button>
                        <button class="btn lightbulb" @click="toggleTheme()" ref="theme"><i
                            class="dev-lightbuld"></i>
                        </button>
                    </div>
                </div>
                <div class="bg-stripe"></div>
            </div>

            <div class="list-group scenarios" v-if="flowRequest.loaded && flowRequest.error === null">
                <div
                    :class="{'test-run-overlay': this.runTestsRequest.loaded === false, 'test-run-overlay-hidden': this.runTestsRequest.loaded === true}"
                    style="transition: 2s all linear; z-index: 87;">
                    <p class="text-center">
                        <span class="loading-spinner loading-spinner-big loading-spinner-green"
                              style="color: rgba(0,0,0,0.4);"></span>
                    </p>
                    <h3 class="text-center" style="color: #7e7e7e; font-weight: 600;">Tests werden ausgeführt...</h3>
                </div>
                <div style="transition: all 0.15s linear;"
                     :class="{'test-running-filter': this.runTestsRequest.loaded === false}">
                    <div class="panel panel-error" v-if="this.compileError" style="margin-top: 5rem;">
                        <h3><i class="dev-icon dev-triangle-alert">&nbsp;</i><strong>Compile Error</strong></h3>
                        <hr>
                        <p class="test-error">{{ this.compileError }}</p>
                    </div>
                    <div class="list-group-item scenario panel " :id="scenario.id"
                         v-for="scenario in flowRequest.flow_data.scenarios">
                        <h3 class="list-group-item-heading">{{ scenario.title }}</h3>
                        <p class="list-group-item-text" v-html="scenario.description"></p>
                        <p class="traceback alert alert-danger scenario-error" style="display: none"></p>
                        <hr class="scenario-hr">
                        <div v-html="scenario.test"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {eventBus, services} from "../../main";
import LanguageBubble from "../campaigns/LanguageBubble";
import {fetchSaveEvent} from "../../services/CommonFunctions";
import mermaid from "mermaid";

export default {
    name: "FlowTestViewerX",
    components: {LanguageBubble},
    props: {
        task: {type: Object},
        campaign: {type: Object},
        commitHashEditor: {type: String, default: ""},
        language: {type: String, default: ""},
        fileList: {type: Array, default: []},
        liveServerUrl: {type: String, default: ""},
        liveStreamCodeUrl: {type: String, default: ""},
        isNewEditor: {type: Boolean, default: false},
    },
    data() {
        return {
            style: null,
            allScenariosSuccessful: false,
            runTestsRequest: {loaded: true, error: null},
            flowRequest: services.flowService.getFlowContent(this.task.task_id),
            commitHashTestRun: "",
            compileError: "",
            campaign: this.campaign,
            currentTask: this.task,
        }
    },
    computed: {
        testRunHotKey() {
            if (window.navigator.platform === "MacIntel") {
                return "⌘S";
            }
            return "Ctrl + S";
        },
        taskSolved() {
            if (this.runTestsRequest.loaded && this.runTestsRequest.error === null && this.runTestsRequest.apiData) {
                if (this.runTestsRequest.apiData.successful && this.commitHashTestRun === this.commitHashEditor) {
                    return true;
                }
            }
            return false;
        },
    },
    mounted() {
        this.runTestsOnSave();
        this.$nextTick(function () {
            window.addEventListener('resize', this.computeStyle);
            mermaid.contentLoaded();
        });
        this.computeStyle();

        eventBus.$on("runTests", function () {
            this.commitHashTestRun = this.commitHashEditor;
            let data = {"commitHash": this.commitHashEditor, "fileList": this.fileList, "language": this.language};

            if (!this.runTestsRequest.loaded) {
                this.runTestsRequest = {loaded: true, error: null};
                return;
            }
            this.runTestsRequest = services.flowService.runTest(
                this.$route.params.challengeId,
                this.$route.params.taskId,
                data
            );
            //clear console output
            eventBus.$emit("consoleOutput", "");
            mermaid.contentLoaded();
        }.bind(this));
        mermaid.contentLoaded();
    },
    beforeDestroy() {
        fetchSaveEvent();
        eventBus.$off("runTests");
    },
    watch: {
        "runTestsRequest.loaded": function () {
            if (this.runTestsRequest.loaded && this.runTestsRequest.error === null) {
                if (this.runTestsRequest.apiData.commit_hash) {
                    // commit_hash is only available on the getTestLastTestStatus api call (when initialize the component)
                    this.commitHashTestRun = this.runTestsRequest.apiData.commit_hash;
                }
                this.compileError = "";
                this.updateTestResults();
                mermaid.contentLoaded();
            }
            if (this.runTestsRequest.loaded && this.runTestsRequest.error !== null) {
                if (this.runTestsRequest.error.status !== 404) {
                    this.compileError = this.runTestsRequest.error.message;

                    // handle timeout
                    if (this.runTestsRequest.error.status === 504) {
                        this.compileError = "The test execution took too long. Maybe your code is not efficient enough? If you think your code is fine, just try again later."
                    }

                    this.updateAllScenarios("error");
                }
            }
        },
        "flowRequest.loaded": function () {
            this.runTestsRequest = services.flowService.getTestStatus(this.task.task_id);
            if (this.flowRequest.loaded) {
                this.$nextTick(function () {
                    mermaid.contentLoaded();
                });
            }

        },
    },
    methods: {
        openCompanyCTA: function () {
            window.open('https://company.platform.entwicklerheld.de/link/twilio-website');
        },
        getCurrentStage: function () {
            if (this.campaign.challenge_data.tasks.length <= 1) {
                return "";
            }
            if (this.campaign.challenge_data.tasks.find(elem => elem.index === 0)) {
                return "Stage\u00A0" + parseInt(this.currentTask.index + 1);
            }
            return "Stage\u00A0" + parseInt(this.currentTask.index);
        },
        isLastStage: function() {
            for (let [index, task] of this.campaign.challenge_data.tasks.entries()) {
                if (task.task_id === this.$route.params.taskId) {
                  return index === this.campaign.challenge_data.tasks.length - 1
                }
            }

            return false;
        },
        runTestsOnSave: function () {
            window.onkeydown = function (event) {
                // fetch save command mac
                if (event.which === 83 && event.metaKey || event.which === 83 && event.ctrlKey) {
                    event.preventDefault();
                    this.runTests();
                }
            }.bind(this);
        },
        runTests: function () {
            eventBus.$emit("runTests");
        },
        submitTask: function () {
            eventBus.$emit("submitTask")
        },
        updateAllScenarios: function (className) {
            let scenarios = document.getElementsByClassName("scenario");
            for (let scenario of scenarios) {
                for (let sentence of scenario.getElementsByTagName("sentence")) {
                    sentence.className = className;
                    let traceback = sentence.getElementsByClassName("traceback");
                    if (typeof traceback[0] !== "undefined") {
                        sentence.removeChild(traceback[0])
                    }
                }
            }
        },
        updateScenario: function (className, scenarioId) {
            let scenarios = document.getElementsByClassName("scenario");
            for (let scenario of scenarios) {
                if (scenario.id !== scenarioId) {
                    continue;
                }
                for (let sentence of scenario.getElementsByTagName("sentence")) {
                    sentence.className = className;
                    let traceback = sentence.getElementsByClassName("traceback");
                    if (typeof traceback[0] !== "undefined") {
                        sentence.removeChild(traceback[0])
                    }
                }
            }
        },
        updateTestResults: function () {
            this.allScenariosSuccessful = this.runTestsRequest.apiData["successful"];
            this.updateAllScenarios("");

            eventBus.$emit("consoleOutput", this.runTestsRequest.apiData["stdout"]);

            let scenarios = document.getElementsByClassName("scenario");
            for (let scenario of scenarios) {
                scenario.getElementsByClassName("scenario-error")[0].style.display = 'none';

                scenarioLoop:
                    for (let sentence of scenario.getElementsByTagName("sentence")) {
                        let traceback = sentence.getElementsByClassName("traceback");
                        if (this.runTestsRequest.apiData.failed_scenarios.length === 0) {
                            sentence.className = "success";
                            if (traceback.length !== 0) {
                                sentence.removeChild(traceback[0]);
                            }
                        }
                        sentence.className = "success";
                        for (let failedScenario of this.runTestsRequest.apiData.failed_scenarios) {
                            // FIXME: Add cast to same type
                            if (scenario.id != failedScenario.scenario_id) {
                                continue;
                            }

                            let noMatchedSentence = failedScenario.failed_sentence_id === -1;
                            if (noMatchedSentence) {
                                this.updateScenario('error', scenario.id);
                                scenario.getElementsByClassName("scenario-error")[0].style.display = 'block';
                                let element = scenario.getElementsByClassName("scenario-error")[0];
                                element.innerText = failedScenario.failure;
                                break scenarioLoop;
                            }


                            if (traceback.length !== 0) {
                                sentence.removeChild(traceback[0]);
                            }
                            if (sentence.id == failedScenario.failed_sentence_id) {
                                sentence.className = "error";
                                let element = document.createElement("div");
                                element.innerText = failedScenario.failure;
                                element.className = "traceback alert alert-danger";

                                sentence.appendChild(element);
                                break scenarioLoop;
                            }
                        }
                    }
            }


            for (let scenario of scenarios) {
                for (let sentence of scenario.getElementsByTagName("sentence")) {
                    let visualization = sentence.getElementsByClassName("visualization");
                    if (visualization.length !== 0) {
                        sentence.removeChild(visualization[0]);
                    }
                    if (this.runTestsRequest.apiData.visualizationData) {
                        for (let visualizationDataItem of this.runTestsRequest.apiData.visualizationData) {
                            if (scenario.id != visualizationDataItem.scenarioId) {
                                continue;
                            }
                            if (sentence.id == visualizationDataItem.sentenceId) {
                                let element = document.createElement("div");
                                element.innerHTML = visualizationDataItem.content;
                                element.className = "visualization";
                                sentence.appendChild(element);
                                mermaid.contentLoaded();
                            }
                        }
                    }
                }
            }
        },
        computeStyle() {
            // Get the window height browser independently
            let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            // remove the header bar
            // FIXME: This should be computed and not be hard coded.
            let navbarHeight = 62;
            try {
                navbarHeight = document.getElementById('navbar_row').offsetHeight;
            } catch (err) {
                console.warn(err);
            }

            windowHeight = windowHeight - navbarHeight - 3;
            this.style = {
                height: `${windowHeight}px`,
                "margin-bottom": 0
            }
        },
        toggleTheme() {
            if (document.documentElement.hasAttribute('theme')) {
                document.documentElement.removeAttribute('theme');
                eventBus.$emit('toggleTheme', 'light');
            } else {
                document.documentElement.setAttribute('theme', 'dark');
                eventBus.$emit('toggleTheme', 'dark');
            }
        },
        openLiveServerLink() {
            window.open(this.liveServerUrl, '_blank');
        },
        reloadPage() {
            window.location.reload();
        },
        shareCode() {
            navigator.clipboard.writeText(this.liveStreamCodeUrl).then(() => console.log("Copied live stream code url to clipboard!"));
        },
    },
}
</script>

<style>
.language-bubble-wrapper {
    padding: 30px 15px 0 15px;
}

.panel-heading-editor {
    padding-top: 0;
}

.current-stage {
    font-size: 1.4rem;
    margin-left: 1rem;
}

.flow-test-viewer sentence {
    display: block;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 2rem;
    border-left: 6px solid #D7E8F9;

}

.flow-test-viewer sentence:nth-child(odd) {
    background: #F8FBFECC;
}

.flow-test-viewer div.successful-scenario > .flow-test-viewer sentence:not(.error), .flow-test-viewer sentence.success {
    border-left-color: #0BC4A2;
}

.flow-test-viewer sentence.error {
    border-left-color: #E74C3C;
}

.flow-test-viewer sentence.error > * {
    margin-top: 1em;
}

.flow-test-viewer .traceback {
    white-space: pre;
    overflow-x: auto;
    margin-left: -2rem;
}

.test-error, .traceback {
    font-family: "Source Code Pro", monospace;
    font-size: 1.2rem;
    white-space: pre;
    overflow-x: scroll;
}

.test-error {
    border-left: 6px #E74C3C solid;
    padding-left: 1rem;
}

.flow-test-viewer {
    border-color: #ddd;
    height: 820px;
    overflow-y: auto;
    position: relative;
    overflow-x: hidden;
}

.flow-test-viewer .scenario {
    padding-top: 3rem;
    padding-bottom: 2rem;
}

.test-running-filter {
    filter: blur(4px);
    opacity: 0.5;
}

.flow-test-viewer .list-group-item-heading {
    margin-bottom: 1rem;
}

.flow-test-viewer .list-group-item-text {
    margin-bottom: 1em;
}

.test-run-overlay-hidden {
    display: none;
    opacity: 0;
    transition: opacity 1s linear;
}

.test-run-overlay {
    z-index: 90;
    position: absolute;
    height: 100%;
    width: 100%;
    padding-top: 7rem;
    transition: all 2s linear;

}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}


@keyframes fill {
    100% {
        box-shadow: inset 0 0 0 30px #7ac142;
    }
}

.scenarios {
    position: relative;
    color: black;
    margin-top: 4rem;
}

.bg-stripe {
    position: absolute;
    /*background: rgb(200, 224, 219);*/
    width: 150%;
    height: 1000px;
    margin-left: -10%;
    transform: rotate(-3deg);
    z-index: -1;
    margin-top: -990px;
}

.spin-fix {
    padding: 0 0.15rem !important;
}

.panel-error > h3 > .dev-icon {
    color: #e74c3c;
}

.panel-error > h3 {
    padding-left: 1rem;
}

.stop {
    background-color: #e74c3c !important;
    color: white !important;
}

.stop:hover {
    background-color: #D93727 !important;
    color: white !important;
}

.lightbulb {
    background-color: white;
    position: absolute;
    top: 1rem;
    right: 1rem;
}

.lightbulb:hover {
    background-color: #F8FBFECC;
}

.lightbulb > i {
    color: #d0b119;
}

.share-code {
    background-color: white;
    position: absolute;
    top: 1rem;
    right: 10rem;
}

.share-code:hover {
    background-color: #F8FBFECC;
}

.reload-editor {
    background-color: white;
    position: absolute;
    top: 1rem;
    right: 5.5rem;
}

.reload-editor:hover {
    background-color: #F8FBFECC;
}

.action-button {
    min-width: 17.5rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
}
</style>

